module.exports = __webpack_public_path__ + "static/media/record-logo1.dc2f125c.png";